var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.26569 5.12922C9.34842 5.04648 9.46064 5 9.57765 5H15.4224C15.5394 5 15.6516 5.04648 15.7343 5.12922L19.8708 9.26569C19.9535 9.34842 20 9.46064 20 9.57765V15.4224C20 15.5394 19.9535 15.6516 19.8708 15.7343L15.7343 19.8708C15.6516 19.9535 15.5394 20 15.4224 20H9.57765C9.46064 20 9.34842 19.9535 9.26569 19.8708L5.12922 15.7343C5.04648 15.6516 5 15.5394 5 15.4224V9.57765C5 9.46064 5.04648 9.34842 5.12922 9.26569L9.26569 5.12922ZM10 6L6 10V15L10 19H15L19 15V10L15 6H10ZM12.5 9.00002C12.7436 9.00002 13 9.25637 13 9.50002V12.6765C13 12.9201 12.7437 13.1176 12.5 13.1176C12.2563 13.1176 12 12.9201 12 12.6765V9.50002C12 9.25637 12.2563 9.00002 12.5 9.00002ZM13 15C13 14.7564 12.7436 14.5 12.5 14.5C12.2563 14.5 12 14.7564 12 15V16C12 16.2437 12.2563 16.5 12.5 16.5C12.7437 16.5 13 16.2437 13 16V15Z",
    fill: "#ED4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.7d9bff0363e9fdadc604beef4512459a.svg";
export { ForwardRef as ReactComponent };